import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AttributionFromFNSimple } from '../models/AttributionFromFNSimple';
@Component({
  selector: 'app-attribution-fromFN-simple',
  templateUrl: './attribution-fromFN-simple.component.html'
})
export class AttributionFromFNSimpleComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'AttributionFromFNSimple'
  @Input() parentForm: FormGroup;
  	@Input() attributionFromFNSimple : AttributionFromFNSimple;

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

